export default {
  Studies: "الدراسات",
  Layouts: "النوافذ",
  Sync: "المزامنة",
  scroll: "التمرير",
  wwwc: "المستويات",
  zoom: "التكبير",
  general: "عام",
  zooming: "التكبير",
  annotation: "القياسات",
  rotating: "الدوران",
  Pan: "التحريك",
  Wwwc: "المستويات بالنقطة",
  WwwcRegion: "المستويات بالمضلع",
  Magnify: "المكبر",
  Zoom: "تكبير",
  Screen: "لقطة شاشة",
  Rotate: "تدوير",
  Flip: "عكس",
  Reset: "إعادة ضبط",
  Eraser: "ممحاة",
  ArrowAnnotate: "A - تسمية",
  Bidirectional: "تقاطع",
  Angle: "زاوية",
  EllipticalROI: "E - بيضاوي",
  FreehandRoi: "خط حر",
  Length: "L - مقياس",
  Probe: "إشارة",
  RectangleRoi: "مستطيل",
  TextMarker: "علامات نصية",
  DragProbe: "مسبار",
  ScaleOverlay: "مقياس",
  OrientationMarkers: "مؤشرات الاتجاه",
  Brush: "فرشاة",
  CircleScissors: "قص بيضاوي",
  FreehandScissors: "قص حر",
  RectangleScissors: "قص مستطيل",
  Invert: "عكس",
  Clip: "تمرير تلقائي",
  Series: "سلاسل",
  Report: "تقرير",
  patientId: "معرف المريض",
  fullname: "الاسم الكامل",
  birthday: "تاريخ الميلاد",
  studyCreatedAt: "تاريخ الدراسة",
  old: "العمر",
  patientSex: "الجنس",
  "Result AI": "نتيجة تحليل الذكاء الاصطناعي",
  "Download dicom": "تحميل سلسلة الذكاء الاصطناعي",
  "Download report": "تحميل التقرير",
  Loading: "جارٍ التحميل",
  Cached: "في التخزين المؤقت",
  male: "ذكر",
  female: "أنثى",
  Copy: "نسخ",
  "Copy ok": "تم النسخ",
  "Copy error": "فشل في النسخ",
  Anonymized: "تم إخفاء الهوية",
  StackScroll: "تمرير متراكم",
  "Result after upload message": "بعد معالجة الدراسة، سيكون التقرير متاحًا",
  "Result ai error message":
    "تعذر معالجة الدراسة، يرجى محاولة تحميل دراسة أخرى",
  error: "خطأ",
  "dcm cannot loading": "تعذر تحميل ملفات .dcm",
  "error read dcm": "خطأ في قراءة الدراسة",
  ai: "تحليل الذكاء الاصطناعي",
  original: "الدراسة الأصلية",
  "How to use title": "دليل الاستخدام",
  "How to use": "تعليمات",
  "ai accept caption": "هل نتيجة التحليل صحيحة؟",
  "thx for feedback": "شكرًا لملاحظاتك!",
  SelectedAccept: { 1: "أشرت أن النتيجة", 2: "تحليل الذكاء الاصطناعي" },
  "accept yes": "صحيحة",
  "accept no": "غير صحيحة",
  "View title": "الدراسة | " + process.env.VUE_APP_INSTALL_NAME,
  Share: "مشاركة",
  "Share done": "تم",
  "Share about": "تم نسخ الرابط إلى الحافظة",
  "Cancel preset": "إلغاء الإعداد",
  Description: "الوصف",
  "About study": "إجابتك",
  CheckReport: "إرسال",
  "Your description": "إجابتك",
  "Best description": "الوصف المثالي",
  "Teacher comment": "تعليق المعلم",
  "Answer exist": "تم الحل",
  "Answer not exist": "لا يوجد إجابة",
  from: "من",
  "Skip all": "تخطي الكل",
  "Add screenshot": "التقاط لقطة شاشة",
  "About screen info":
    "يمكنك إضافة تعليقات ولقطات شاشة من العارض (على اليسار) باستخدام زر 'التقاط لقطة شاشة'، أو تحميلها من الكمبيوتر.",
  "Screenshot doned": "تم",
  PlanarFreehandROI: "R - مخطط",
  MPR: "إعادة بناء متعددة المستويات",
  "Disable MPR First": "يرجى تعطيل وضع MPR أولاً",
  Crosshairs: "MIP ومحاور",
  "MPR: only for 2+": "غير متاح لـ MPR",
  "MPR: hpu tier == 0": "جهازك لا يدعم إعادة الإعمار",
  "MPR: modality not support": "وضع MPR غير مدعوم لـ <modality>",
  "Cannot loading screen -- adblock":
    "تعذر تحميل لقطة الشاشة. يرجى تعطيل الإضافات مثل VPN أو مانع الإعلانات",
  "Cannot loading screen -- s3 request":
    "تعذر تحميل لقطة الشاشة. حاول لاحقًا أو اتصل بالدعم",
  "Cannot loading screen -- upload":
    "تعذر تحميل لقطة الشاشة. حاول لاحقًا أو اتصل بالدعم",
  voi: "السطوع",
  camera: "تحريك / تكبير",
  "Remove?": "حذف؟",
  Support: "الدعم",
  "Support info": "يمكنك طرح سؤال أو الإبلاغ عن مشكلة",
  "Send work?": "هل تريد إرسال العمل للمراجعة؟",
  shareAIResult:
    "شاهد كيف قام الذكاء الاصطناعي بمعالجة الدراسة على منصة “" +
    process.env.VUE_APP_INSTALL_NAME +
    "”:",
  "Edit study": "تحرير الإجابة",
};
